import { ListSubheader, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { useState } from 'react';
import { Roi } from '~/domain/dicom/dicomstructureset';

import StructureLayer from './Structure';

const formatUniqueROIKey = (roi: Roi, sopUid: string) =>
    `${sopUid}-${roi.roiNumber}`;

interface StructureListProps {
    title: string;
    rois: Roi[];
    currentStructureSetSopInstanceUID: string;
    onDelete: (roiNumber: number, sopUid: string) => void;
    assignRef: (roiNumber: number, el: HTMLDivElement | null) => void;
    initialExpanded?: boolean;
    menuRef?: React.RefObject<HTMLElement | undefined>;
}

export default function StructureList({
    title,
    rois,
    currentStructureSetSopInstanceUID,
    onDelete,
    assignRef,
    initialExpanded = true,
    menuRef,
}: StructureListProps) {
    const [isExpanded, setIsExpanded] = useState(initialExpanded);

    if (rois.length === 0) {
        return null;
    }

    return (
        <li>
            <ul>
                <ListSubheader
                    onClick={() => setIsExpanded(!isExpanded)}
                    sx={{
                        padding: 0,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        color: 'primary.main',
                        cursor: 'pointer',
                        lineHeight: 0,
                        position: 'relative',
                        zIndex: 0,
                    }}
                >
                    <Box>
                        {isExpanded ? (
                            <ChevronDown size={14} />
                        ) : (
                            <ChevronRight size={14} />
                        )}
                    </Box>
                    <Typography
                        sx={{
                            color: 'primary.main',
                            fontWeight: 400,
                            fontSize: 12,
                            lineHeight: 2.5,
                        }}
                    >{`${title} (${rois.length})`}</Typography>
                </ListSubheader>
                {isExpanded &&
                    rois.map((roi) => (
                        <div
                            key={formatUniqueROIKey(
                                roi,
                                currentStructureSetSopInstanceUID
                            )}
                            ref={(el) => assignRef(roi.roiNumber, el)}
                        >
                            <StructureLayer
                                menuRef={menuRef}
                                roi={roi}
                                onDelete={(roiNumber) =>
                                    onDelete(
                                        roiNumber,
                                        currentStructureSetSopInstanceUID
                                    )
                                }
                            />
                        </div>
                    ))}
            </ul>
        </li>
    );
}
